exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3GgkZ{font-size:14px}", ""]);

// exports
exports.locals = {
	"input": "_3GgkZ"
};